module.exports = __webpack_public_path__ + "img/90182b5.png";